import React from "react";
import { FormHelperText } from "@material-ui/core";
import { AccessTime } from "@material-ui/icons";
import { KeyboardTimePicker } from "@material-ui/pickers";
import {
  FormControl, InputLabel, MenuItem, Select,
} from "@mui/material";

export function CommonDropdown(props) {
  const {
    options = [],
    inputLabel = "",
    selectedValue,
    onChangeHandler,
    name,
    error,
    required,
  } = props;
  return (
    <FormControl required={required} variant="standard" sx={{ width: "100%" }}>
      <InputLabel
        id="demo-simple-select-standard-label"
        sx={{
          "&.MuiFormLabel-root": {
            marginTop: "-16px",
          },
        }}
      >
        {inputLabel}
      </InputLabel>
      <Select
        name={name}
        sx={{
          "& .MuiInput-root": {
            paddingBottom: "5px",
          },
          "& .MuiSvgIcon-root": {
            fill: "black",
          },
          "&.MuiInputBase-root": {
            marginTop: 0,
          },
        }}
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        value={selectedValue}
        onChange={onChangeHandler}
        label="Contract Type"
        MenuProps={{ PaperProps: { sx: { maxHeight: "40%" } } }}
        error={error || false}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            style={{
              display: "flex",
              padding: "8px",
              justifyContent: "flex-start",
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <FormHelperText sx={{ color: "red" }}>
          This field is required.
        </FormHelperText>
      )}
    </FormControl>
  );
}

export function CommonTimePicker(props) {
  const {
    name = "",
    value = new Date(),
    onChangeHandler,
    TextFieldComponent,
    requried = false,
  } = props;
  return (
    <KeyboardTimePicker
      requried={requried}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 0,
          paddingRight: 0,
          "&.Mui-focused fieldset, &:hover": {
            borderWidth: "0 0 2px 0",
            borderColor: "black",
          },
        },
        "& .MuiOutlinedInput-input": {
          padding: "8px 0 2px 10px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderWidth: "0 0 1px 0",
        },
        "& .MuiSvgIcon-root": {
          fill: "black",
        },
      }}
      variant="standard"
      name={name}
      margin="normal"
      value={value}
      ampm={false}
      onChange={(time) => onChangeHandler({ target: { name, value: time } })}
      KeyboardButtonProps={{
        "aria-label": "change time",
      }}
      TextFieldComponent={TextFieldComponent}
      keyboardIcon={<AccessTime />}
    />
  );
}
